import { FlashcardFormFields } from '@/components/question/forms/flashcard/FlashcardForm';
import { flashcardQuestionGenerator } from '@/data/generators/flashcardQuestionGenerator';
import { FlashcardQuestion } from '@/models/Question';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterFlashcardForm(
  flashcard: FlashcardFormFields,
): FlashcardQuestion {
  return flashcardQuestionGenerator({
    title: normalizeTranslatableField(flashcard.title),
    frontContent: normalizeTranslatableField(flashcard.frontContent),
    backContent: normalizeTranslatableField(flashcard.backContent),
    showFrontOnBack: flashcard.showFrontOnBack,
  });
}